<template>
  <div>
    <div class="landscape">
      <div :class="{ empty: !halShow, HAL: halShow, slideOut: slideOutHal }">
        <div style="position: absolute; left: 50%; top: 70%">
          <div v-show="animateMessage" class="halMessage typewriter passworld">
            <p>{{ message }}</p>
            <transition name="side-fade">
              <div class="onboard" v-show="showGetOnBoard" @click="toMainHall">
                get_onboard
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="spaceshipHall" :class="{ slideIn: slideIn }"></div>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import { delay } from "@/variables.js";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
import { SC } from "@/plugins/soundcloud.js";
import firebase from "firebase";
require("firebase/auth");

export default {
  name: "Spaceship",
  mixins: [MainMixin],
  components: {
    NotOriented,
  },
  title: "Spaceship",
  data() {
    return {
      halShow: false,
      animateMessage: false,
      slideIn: false,
      slideOutHal: false,
      message: "",
      showGetOnBoard: false,
    };
  },
  methods: {
    showShip() {
      delay(500).then(() => {
        this.halShow = true;
        delay(1500).then(() => {
          this.animateMessage = true;
          delay(2000).then(() => {
            this.showGetOnBoard = true;
          });
        });
      });
    },
    authAnonym() {
      firebase
        .auth()
        .signInAnonymously()
        .then(() => {
          firebase.auth().onAuthStateChanged((anonymous) => {
            this.$store.commit("setAnonymousUser", anonymous);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    toMainHall() {
      try {
        var iframeElement = document.getElementById("ifrm");
        var iframeElementID = iframeElement.id;
        let widget = SC.Widget(iframeElementID);
        widget.play();
      } catch (e) {
        console.log(e);
      } finally {
        delay(1000).then(() => {
          this.slideIn = true;
          this.slideOutHal = true;
          delay(2500).then(() => {
            this.$router.push("/main-hall");
          });
        });
      }
    },
  },
  /*eslint-disable*/
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/passworld") {
        vm.message = "you found us, welcome to the last humain stronghold...";
      } else {
        vm.message = "welcome back captain..";
      }
    });
  },
  mounted() {
    this.init();
    this.authAnonym();
    this.showShip();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/landing-error.scss";

.typewriter p {
  font-size: 3vw;
  min-width: auto;
}

.onboard {
  text-align: center;
  font-size: 3vw;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 15px;
  padding: 5px;
  width: max-content;
  position: inherit;
  left: 40%;
}

.empty {
  position: relative;
  margin: -20px;
  bottom: -20px;
  min-width: 100vw;
  min-height: 100vh;
  opacity: 0;
}

.HAL {
  position: relative;
  left: 0%;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../assets/medias/images/spaceshipreal.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: right 50%;
  opacity: 1;
  transition: 2s;
  background-color: black;
}

.halMessage {
  left: -50%;
  margin: auto;
  position: relative;
  z-index: 2;
}

.spaceshipHall {
  position: absolute;
  top: 0px;
  left: 100%;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../assets/medias/images/hall1.png");
  background-size: 100vw 100vh;
  z-index: 3;
}

.slideIn {
  left: 0px;
  transition: 2s ease-in-out;
}

.slideOut {
  left: -100%;
  transition: 2s ease-in-out;
}

@media screen and (max-width: 730px) {
  .typewriter p {
    font-size: 3vw;
  }
}
</style>
